import { gql } from 'graphql-request';

import { requestWithAuth } from '@/utilities/graphQLClient';

import type { NarrativeFragmentType } from '../narrativeFragment';
import type { NarrativeValuationCompany } from '../useNarrativeValuationCompany';
import { NARRATIVE_FRAGMENT } from '../narrativeFragment';
import { COMPANY_FRAGMENT } from '../companyFragment';
import { UpdateNarrativeInput } from './types';

export type QueryResponse = {
  updateNarrative: NarrativeFragmentType & {
    company: NarrativeValuationCompany;
  };
};

export const mutationFn = async (input: UpdateNarrativeInput) => {
  const response = await requestWithAuth<QueryResponse>(
    gql`
      mutation UpdateNarrative($input: UpdateNarrativeInput!) {
        updateNarrative(input: $input) {
          ...NarrativeFields
          company {
            ...CompanyFields
          }
        }
      }
      ${COMPANY_FRAGMENT}
      ${NARRATIVE_FRAGMENT}
    `,
    {
      input,
    }
  );

  return response.updateNarrative;
};
